import { memo } from 'react';

import SvgIcon from '@material-ui/core/SvgIcon';

import { colors } from '../theme/palette';
import { SvgIconProps } from './SvgIcon.types';

export const PencilIcon = memo(({ className, color = colors.primary.main, fontSize = 24, style }: SvgIconProps) => {
  return (
    <SvgIcon
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      fontSize="inherit"
      className={className}
      style={{ ...style, fontSize, fill: 'none' }}
    >
      <path
        d="M20.6239 4.37611C20.0664 3.81858 19.3496 3.5 18.5531 3.5C17.7566 3.5 17.0398 3.81858 16.4823 4.37611L4.93363 15.9248L3.5 21.4204L8.99558 19.9867L20.6239 8.5177C21.1814 7.96018 21.5 7.24336 21.5 6.4469C21.5 5.65044 21.1814 4.93363 20.6239 4.37611Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.1641 4.77435L20.226 8.8363"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.93359 15.9248L8.99554 19.9868"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
});
